/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500,
} from "../../types/pecegePayCreditCardController/PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay } from "../../clients/pecegePayCreditCardController/patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay.ts";

export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationKey =
  () =>
    [
      { url: "/api/v1/pecegepay/creditcard/:courseFinPersonPaymentId/pay" },
    ] as const;

export type PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationKey =
  ReturnType<
    typeof patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationKey
  >;

export function patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationKey();
  return mutationOptions<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams["courseFinPersonPaymentId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ courseFinPersonPaymentId }) => {
      return patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay(
        courseFinPersonPaymentId,
        config,
      );
    },
  });
}

/**
 * @description Efetua o pagamento de uma parcela com cartão de crédito.
 * @summary Pagar parcela
 * {@link /api/v1/pecegepay/creditcard/:courseFinPersonPaymentId/pay}
 */
export function usePatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500
      >,
      {
        courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams["courseFinPersonPaymentId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationKey();

  const baseOptions =
    patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401
        | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500
      >,
      {
        courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams["courseFinPersonPaymentId"];
      },
      TContext
    >;

  return useMutation<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams["courseFinPersonPaymentId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams["courseFinPersonPaymentId"];
    },
    TContext
  >;
}
